import { change } from 'redux-form';
import { replace } from 'react-router-redux';

import { handleErrorException, loading, success } from 'State/actions';
import { CREATE_EDIT_USAGE_FORM_NAME } from 'Common/FormEnum';
import { CreateEditUsageEnum, FilterEnum } from 'Common/FieldEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getUsageDetail = usageID => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_USAGE_DETAIL, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `Usage/ViewUsageItems/${usageID}`
      );
      dispatch(success(types.SELECTED_USAGE_DETAIL, response.data.Data));
      dispatch(
        success(
          types.CREATE_EDIT_USAGE_ITEMS,
          response.data.Data[CreateEditUsageEnum.UsageItems]
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Usage Detail. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCHING_USAGE_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCHING_USAGE_DETAIL, false));
    }
  };
};

export const getUsageItems = (fetchData, isReOrderItemList, infoList) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.USAGE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Usage/GetUsageItems',
        fetchData
      );
      response.data.Data[CreateEditUsageEnum.UsageItems] &&
        dispatch(
          success(
            types.CREATE_EDIT_USAGE_ITEMS,
            response.data.Data[CreateEditUsageEnum.UsageItems]
          )
        );

      if (isReOrderItemList && infoList) {
        dispatch(reorderItemList(infoList));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Usage Items. Please try again',
      };
      dispatch(
        handleErrorException(ex, types.USAGE_ITEMS_LOADING_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.USAGE_LOADING, false));
    }
  };
};

export const clearInvalidPreviewData = data => {
  return async dispatch => {
    dispatch(
      change(
        CREATE_EDIT_USAGE_FORM_NAME,
        CreateEditUsageEnum.UsageItemsInfo,
        data
      )
    );
  };
};

export const resetFilterOnClickOfPreviousPage = () => {
  return async dispatch => {
    dispatch(change(CREATE_EDIT_USAGE_FORM_NAME, [FilterEnum.GroupId_Bid], 0));
    dispatch(change(CREATE_EDIT_USAGE_FORM_NAME, [FilterEnum.GroupId_Item], 0));
  };
};

export const emptyItemList = () => {
  return {
    type: types.CREATE_EDIT_USAGE_ITEMS,
    payload: [],
  };
};

export const emptyEditDulObject = () => {
  return {
    type: types.SELECTED_USAGE_DETAIL,
    payload: null,
  };
};

export const saveUsage = (model, resetScroll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_USAGE_DETAIL, true));
    resetScroll();
    try {
      await MPWWebApi.postGenericInsertUpdate('Usage/WriteUsage', model);
      dispatch(resetDirty());
      dispatch(success(types.USAGE_DETAIL_SUBMIT));
      dispatch(replace('/usage'));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while saving Usage. Please try again',
      };
      dispatch(
        handleErrorException(ex, types.SUBMIT_USAGE_DETAIL_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.SUBMITTING_USAGE_DETAIL, false));
    }
  };
};

export const reorderItemList = items => {
  return {
    type: types.RE_USAGE_ITEM_LIST,
    payload: items,
  };
};

export const clearOrderSubmitError = () => {
  return {
    type: types.CLEAR_USAGE_ERROR_SUCCESS,
  };
};

export const clearUsageItemGridData = () => {
  return change(
    CREATE_EDIT_USAGE_FORM_NAME,
    CreateEditUsageEnum.UsageItemsInfo,
    []
  );
};

export const setModifiedUsageItems = newData => {
  return change(
    CREATE_EDIT_USAGE_FORM_NAME,
    CreateEditUsageEnum.UsageItemsInfo,
    newData
  );
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/CreateEditUsage/actions.js